import DetailsShimmer, { DetailsShimmerProps } from './detailsShimmer'

// No logic — passthrough kept for the two-file pattern.
const DetailsShimmerWrapper = (props: DetailsShimmerProps) => {
    return <DetailsShimmer {...props} />
}

export { DetailsShimmerWrapper }
export type { DetailsShimmerProps }
export default DetailsShimmerWrapper
